<div class="width-hack"
     [class.never-hide]="neverHide">
</div>
<div *ngIf="isMenuVisibleOnSmallScreen"
     class="menu-toggler-background"
     (click)="onToggleMenuClicked($event)">
</div>

<div class="wrapper mat-elevation-z2"
     style="z-index: 999;"
     [class.small-screen-hider]="!isMenuVisibleOnSmallScreen"
     [class.never-hide]="neverHide">
    <div class="top" fxLayout="row" fxLayoutAlign="space-between center">
        <div>
            <img class="logo" [src]="conf.assetsUrl + 'img/header-logo.png'" (click)="onHeaderClicked()" />
        </div>
        <div>
            <button mat-mini-fab
                    class="menu-toggler"
                    [class.never-hide]="neverHide"
                    color="default"
                    (click)="onToggleMenuClicked($event)">
                <mat-icon *ngIf="!isMenuVisibleOnSmallScreen" color="accent">menu</mat-icon>
                <mat-icon *ngIf="isMenuVisibleOnSmallScreen" color="accent">close</mat-icon>
            </button>
        </div>
    </div>
    <div class="content">
        <mat-nav-list>
            <mat-list-item>
                <a matLine routerLink="/{{ this.dashboardUrl }}/diary/{{ defaultDay }}">{{ 'Calendar' | translate}}</a>
            </mat-list-item>
            <mat-list-item>
                <a matLine routerLink="/{{ this.dashboardUrl }}/feedback">{{ 'Feedback' | translate}}</a>
            </mat-list-item>
            <mat-list-item>
                <a matLine routerLink="/{{ this.dashboardUrl }}/plan">{{ 'AnnualPlan' | translate}}</a>
            </mat-list-item>
            <mat-list-item>
                <a matLine routerLink="/{{ this.dashboardUrl }}/documents">{{ 'Documents' | translate}}</a>
            </mat-list-item>
            <mat-list-item>
                <a matLine routerLink="/{{ this.dashboardUrl }}/evaluations">{{ 'Evaluations' | translate}}</a>
            </mat-list-item>
            <mat-list-item>
                <a matLine routerLink="/{{ this.dashboardUrl }}/tests">{{ 'Tests' | translate}}</a>
            </mat-list-item>
            <mat-list-item>
                <a matLine routerLink="/{{ this.dashboardUrl }}/users/{{ this.athleteUser.id }}/edit">{{ 'My_account' | translate}}</a>
            </mat-list-item>
        </mat-nav-list>

        <!--<ng-content></ng-content>-->
    </div>
    <div class="footer">
        <mat-nav-list>
            <mat-list-item (click)="onLogoutClicked()">
                <a matLine href="/logout">{{ 'Disconnect' | translate}}</a>
            </mat-list-item>
        </mat-nav-list>
    </div>
</div>
